import * as types from './actionTypes';
import {PastOrderService} from "./pastOrderService";

export function getPastOrders(number, unit, accessToken) {
  return dispatch => {
    return PastOrderService.pastOrders(number, unit, accessToken)
      .then(result => {
          return dispatch(dispatchPastOrderData(result));
      })
      .catch(error => {
        throw(error);
      })
  }
}

function dispatchPastOrderData(pastOrderData) {
  return {type: types.PAST_ORDER_DATA, pastOrderData: pastOrderData}
}


export function storeSelectedPastNumber(selectedpastnumber) {
    return dispatch => {
        return dispatch(dispatchSelectedPastNumber(selectedpastnumber));
    }
}

function dispatchSelectedPastNumber(selectedpastnumber) {
    return {type: types.SELECTED_PAST_NUMBER, selectedpastnumber: selectedpastnumber}
}


// WEBPACK FOOTER //
// ./src/service/pastOrderActions.js